import React, { forwardRef, useLayoutEffect, useRef } from "react";

import useEventListener from "../../../Hooks/useEventListener";
import BaseModal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from "./BaseModal";
import Button from "../forms/Button";

const Modal = ({
  title,
  children,
  isOpen,
  setIsOpen,
  id,
  titleId,
  isStaticBackdrop,
  isScrollable,
  isCentered,
  size,
  fullScreen,
  isAnimation = true,
  onSubmit,
  isBtnShow = true,
  isCrossBtnShow = true,
  BtnChildren,
  ...props
}) => {
  const refModal = useRef(null);
  const ref = useRef(null);

  // <body> modal-open class
  useLayoutEffect(() => {
    if (isOpen) {
      document.body.classList.add("modal-open");
    }
    return () => {
      document.body.classList.remove("modal-open");
    };
  });

  // Backdrop close function
  const closeModal = (event) => {
    if (
      ref.current &&
      !ref.current.contains(event.target) &&
      !isStaticBackdrop
    ) {
      setIsOpen(false);
    }
  };
  useEventListener("mousedown", closeModal);
  useEventListener("touchstart", closeModal);

  // Backdrop static function
  const modalStatic = (event) => {
    if (
      ref.current &&
      !ref.current.contains(event.target) &&
      isStaticBackdrop
    ) {
      if (refModal.current) {
        refModal.current.classList.add("modal-static");
        setTimeout(
          () => refModal.current.classList.remove("modal-static"),
          300
        );
      }
    }
  };
  useEventListener("mousedown", modalStatic);
  useEventListener("touchstart", modalStatic);

  // Keypress close function
  const escFunction = (event) => {
    if (event.key === "Escape") {
      setIsOpen(false);
    }
  };
  useEventListener("keydown", escFunction);

  return (
    <BaseModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      titleId={titleId}
      title={title}
      id={id}
      isStaticBackdrop={isStaticBackdrop}
      isScrollable={isScrollable}
      isCentered={isCentered}
      size={size}
      fullScreen={fullScreen}
      isAnimation={isAnimation}
    >
      <ModalHeader setIsOpen={setIsOpen} isCrossBtnShow={isCrossBtnShow} className="p-4">
        <ModalTitle id={id}>{title || ""}</ModalTitle>
      </ModalHeader>
      <form onSubmit={onSubmit} noValidate>
        <ModalBody className="px-4">
          <div className="row g-4">{children}</div>
        </ModalBody>
        <ModalFooter isBtnShow={isBtnShow} className="px-4 pb-4">
          {BtnChildren ? (
             <>{BtnChildren()}</>
          ) : (
            <Button color="primary" type="submit" icon="Save">
              Save
            </Button>
          )}
        </ModalFooter>
      </form>
    </BaseModal>
  );
};

export default Modal;
